import { createClient } from 'contentful'

export default createClient({
  space: 'knzoek0tzynn',
  accessToken: 'p5UxB75hrXFFNjmQNz7USRmpferW_Yu_I-c_tJdcUzs',
})
